import { render, staticRenderFns } from "./BrandUpload.vue?vue&type=template&id=4f287fe3&"
import script from "./BrandUpload.vue?vue&type=script&lang=js&"
export * from "./BrandUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports